<script setup lang="ts">
import type { AgentOnPage } from '@@/shared/agent/api-types';

const props = defineProps<{
  agent: AgentOnPage
}>();

const { t } = useI18n();
const legalDescription = computed(() => {
  return t(`agent.about.description.legal_${props.agent.displayGender}`, {
    // use translation pluralization to display ≠ message depending on RSAC existence
    // Agents have 60 days to provide their RSAC number, in the meantime, they can be broadcasted without it
    count: props.agent.legal.rsac?.number == null ? 1 : 2,
    rsacNumber: props.agent.legal.rsac?.number,
    rsacCity: props.agent.legal.rsac?.place,
  });
});
</script>

<template>
  <IadWrapper
    class="bg-neutral-80 rounded-t-3xl lg:rounded-t-none"
    inner-classes="py-xl flex flex-col lg:grid grid-cols-12 gap-m"
  >
    <IadTitle
      class="col-span-7"
      :text="$t(`agent.about.title`)"
      tag="h3"
    />
    <ClientOnly>
      <AgentSocialNetworks
        v-if="agent.socialNetworks.length"
        class="col-span-5 justify-self-end self-start"
        :agent
      />
    </ClientOnly>
    <IadTextWithOverflow class="col-span-7">
      <!-- eslint-disable vue/no-v-html -->
      <div v-html="agent.description" />
      <p v-text="legalDescription" />
    </IadTextWithOverflow>
  </IadWrapper>
</template>
